import Results from './components/Results.vue';
import Event from './components/Event.vue';
import Relay from './components/Relay.vue';
import Events from './components/Events.vue';
import Athlete from './components/Athlete.vue';

export default [
    //{ path: '/', component: showBlogs},
    { path: '/results/:date', component: Results},
    { path: '/events', component: Events},
    { path: '/eventno', component: Event},
    { path: '/relayno', component: Relay},
    { path: '/athlete', component: Athlete}
]
